import React from "react";
import OrderDetialsLayout from "../layouts/OrderDetialsLayout";
import SubscriptionCard from "./SubscriptionCard";

import numeral from "numeral";
import { useSelector, useDispatch } from "react-redux";

const OrderDetails = ({ company }) => {
  let [coupon, setCoupon] = React.useState("");
  const nav = useSelector((state) => state.nav);
  const ikPass = useSelector((state) => state.nav.ikPass);
  const ikPassSingle = useSelector((state) => state.nav.ikPassSingle);
  const isSubscription = useSelector((state) => state.nav.subscription);
  const curSubscriptionTier = useSelector(
    (state) => state.nav.curSubscriptionTier,
  );
  const isCurSubscriptionTier = Object.keys(curSubscriptionTier).length > 0;
  const hiddenCoupon = true;
  const total_due = numeral(company.presenter.total_due).format("$0,0[.]00");
  const credit_to_give = !ikPass
    ? numeral(Number(company.presenter.credit_to_give)).format("$0,0[.]00")
    : numeral(Number(company.presenter.get_amount)).format("$0,0[.]00");

  const locCountToUse = !!ikPassSingle
    ? null
    : !!company?.presenter?.display_map_siblings
      ? company.presenter.project_location_count
      : company.presenter.brand_location_count;

  const ha_credit = numeral(Number(company.presenter.credit_to_give)).format(
    "$0,0.00",
  );
  const subtotal = !!ikPass
    ? numeral(Number(company.presenter.pay_amount)).format("$0,0.00")
    : numeral(Number(company.presenter.subtotal)).format("$0,0.00");
  const user = useSelector((state) => state.user);
  const isSub = !!ikPass && !!user?.subscription?.name ? true : false;
  const upgradeVal = !!isSub
    ? Number(company.presenter.pay_amount) -
      Number(user.subscription.amount_to_charge)
    : 0;
  return (
    <div className="order-details">
      {!!isSubscription ? (
        <SubscriptionCard />
      ) : (
        <div className="card ">
          <div className="card-col">
            <div
              className={`card-feature ${
                credit_to_give.length > 7 ? "long-number" : ""
              }`}
            >
              {credit_to_give}
              {!!ikPass && <span className="ikpass-month">/mo</span>}
            </div>
            {company.presenter.is_inkind_cash && (
              <div className=" ha-title">inKind e-Gift Card</div>
            )}
            {!company.presenter.is_inkind_cash && (
              <div className=" ha-title">
                {!!company?.presenter?.display_map_siblings
                  ? company.presenter.project_name
                  : company.presenter.brand_name}{" "}
                {company.presenter.bonus_credit != "$0.00"
                  ? company.presenter.is_inkind_cash
                    ? "inKind Cash"
                    : company.presenter.icos_for_purchase_page
                      ? "Gift Card"
                      : "House Account"
                  : "Gift Card"}
              </div>
            )}
            {!!ikPass && (
              <div className=" ha-title">
                inKind Pass Subscription ({company.presenter.name})
              </div>
            )}
            {!!ikPass && (
              <div className="good-for">
                Access any inKind restaurant partner nationwide
              </div>
            )}
            {!company?.presenter?.icos_for_purchase_page &&
              !company?.presenter?.is_inkind_cash && (
                <div className="good-for">
                  {!!company?.presenter?.icos_for_purchase_page
                    ? ""
                    : `${locCountToUse} Location${
                        locCountToUse > 1 ? "s" : ""
                      } | `}
                  Good for food{company.presenter.redeem_alcohol ? "," : " and"}{" "}
                  beverages {company.presenter.redeem_alcohol && " and alcohol"}
                </div>
              )}
            {(company?.presenter?.icos_for_purchase_page ||
              company?.presenter?.is_inkind_cash) &&
              !ikPass && (
                <div className="good-for">
                  Redeemable at{" "}
                  {!!company?.presenter?.display_map_siblings
                    ? company.presenter.project_name
                    : company.presenter.brand_name}{" "}
                  <br />
                  {company?.presenter?.icos_for_purchase_page ? "and" : ""}{" "}
                  {company.presenter.project_location_count}+ restaurants
                </div>
              )}
          </div>
        </div>
      )}

      {!!isSubscription && !isCurSubscriptionTier ? null : (
        <>
          {!hiddenCoupon || !!ikPass ? (
            <div className="coupon-cont">
              <div className="coupon-grid">
                {" "}
                <input
                  id="coupon code"
                  name="coupon code"
                  type="text"
                  placeholder="Promo or referral code"
                  onChange={({ target }) => {
                    setCoupon(target.value);
                  }}
                />
                <button
                  onClick={() => alert("Not a valid coupon")}
                  className={`apply-btn ${coupon ? "actionable" : "dead"}`}
                  disabled={!coupon}
                >
                  Apply
                </button>
              </div>
            </div>
          ) : (
            <div className="coupon-absent"></div>
          )}

          {!!ikPass ? (
            <div className="order-deets checkout-base-font ikpass-container">
              <div style={{ display: !isSub && "none" }}>
                <OrderDetialsLayout>
                  <span>
                    {upgradeVal >= 0 ? "Upgrade" : "Downgrade"} to{" "}
                    {company?.presenter?.name}:
                  </span>
                  <span>
                    {upgradeVal >= 0
                      ? "$" + upgradeVal
                      : "-$" + Math.abs(upgradeVal)}
                  </span>
                </OrderDetialsLayout>
                <div
                  className="details-width bonus-disclosure"
                  style={{
                    paddingTop: "0px",
                    marginTop: "-4px",
                    paddingBottom: "4px",
                  }}
                >
                  The difference in your current plan and the new plan.
                </div>
              </div>

              <div>
                <OrderDetialsLayout>
                  <span>{!!isSub && "(New) "}Monthly Subscription Fee:</span>
                  <span>${company.presenter.pay_amount}</span>
                </OrderDetialsLayout>
                <div
                  className="details-width bonus-disclosure"
                  style={{
                    paddingTop: "0px",
                    marginTop: "-4px",
                    paddingBottom: "4px",
                  }}
                >
                  Renews every month on the 7th. Cancel any time.
                </div>
              </div>
              <OrderDetialsLayout>
                <span>{!!isSub && "(New) "}Monthly Complimentary Bonus:</span>
                <span>
                  +$
                  {Number(company.presenter.get_amount) -
                    Number(company.presenter.pay_amount)}
                </span>
              </OrderDetialsLayout>
              <OrderDetialsLayout>
                <span className="font-bold">
                  Total Monthly inKind Pass Value:
                </span>
                <span className="font-bold">+{credit_to_give}</span>
              </OrderDetialsLayout>
            </div>
          ) : !!isSubscription ? (
            <div className="order-deets checkout-base-font">
              <OrderDetialsLayout>
                <span>
                  inKind Pass -{" "}
                  {curSubscriptionTier.billing_interval === "monthly"
                    ? "Monthly"
                    : "Yearly"}{" "}
                  Subscription
                </span>
                <span>
                  {numeral(curSubscriptionTier?.amount_to_charge).format(
                    "$0,0.00",
                  )}
                </span>
              </OrderDetialsLayout>
              {!!curSubscriptionTier?.number_of_free_months &&
              curSubscriptionTier.number_of_free_months > 0 ? (
                <OrderDetialsLayout>
                  <span>
                    {curSubscriptionTier.number_of_free_months} Month
                    {curSubscriptionTier.number_of_free_months > 1
                      ? "s"
                      : ""}{" "}
                    Free
                  </span>
                  {curSubscriptionTier.billing_interval === "monthly" ? (
                    <span className="sub-card__bonus">
                      -
                      {numeral(
                        Number(
                          curSubscriptionTier?.amount_to_charge *
                            curSubscriptionTier.number_of_free_months,
                        ),
                      ).format("$0,0.00")}
                    </span>
                  ) : null}
                </OrderDetialsLayout>
              ) : null}
            </div>
          ) : (
            <div className="order-deets checkout-base-font">
              <OrderDetialsLayout>
                <span>Subtotal</span>
                <span>
                  {company.presenter.has_open_amount_options &&
                  company.presenter.open_amount_bonus === "Discount"
                    ? ha_credit
                    : subtotal}
                </span>
              </OrderDetialsLayout>
              {(!company.presenter.has_open_amount_options ||
                company.presenter.open_amount_type ===
                  "flat_bonus_amount_per_spend") &&
                company.presenter.bonus_credit != "$0.00" && (
                  <OrderDetialsLayout>
                    <span>Free Bonus</span>
                    <span>+ {company.presenter.bonus_credit}</span>
                  </OrderDetialsLayout>
                )}
              {company.presenter.has_open_amount_options &&
                (company.presenter.open_amount_type === "flat_bonus_percent" ||
                  company.presenter.open_amount_type ===
                    "flat_discount_percent") &&
                company.presenter.bonus_credit != "$0.00" && (
                  <OrderDetialsLayout>
                    <span>
                      {company.presenter.open_amount_percentage}%{" "}
                      {company.presenter.open_amount_bonus}
                    </span>
                    <span>
                      {company.presenter.open_amount_bonus === "Discount"
                        ? "-"
                        : "+"}{" "}
                      {company.presenter.bonus_credit}
                    </span>
                  </OrderDetialsLayout>
                )}

              <div className="details-width line1 font-bold">
                <div className="ha-credit">
                  <span>
                    {company.presenter.bonus_credit != "$0.00"
                      ? company.presenter.is_inkind_cash
                        ? "e-Gift Card Amount"
                        : company?.presenter?.icos_for_purchase_page
                          ? "Gift Card Amount"
                          : "House Account Credit"
                      : "E-Gift Card Amount"}
                  </span>
                  <span>{ha_credit}</span>
                </div>
              </div>
            </div>
          )}
          <div className="details-width line2">
            <div className="total-due">
              {!!isSubscription ? (
                <span>Due Today</span>
              ) : (
                <span>Total Due {!!ikPass && "Today"}</span>
              )}
              <span className="font-bold">
                {!!isSubscription
                  ? numeral(
                      !curSubscriptionTier?.number_of_free_months
                        ? curSubscriptionTier?.amount_to_charge
                        : 0,
                    ).format("$0,0.00")
                  : subtotal}
              </span>
            </div>
          </div>
          {!isSubscription ? (
            <div className="details-width bonus-disclosure">
              Bonus credit expires after 3 years. Paid credit never expires.
              {!!ikPass && (
                <div style={{ paddingTop: "4px" }}>
                  Any unused credit rolls over to the next month.
                </div>
              )}
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};

export default OrderDetails;
